/** Sign in: a passkey (one tap on the phone, SPEC §13.2) or username and password. */
import { startAuthentication, type PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser'
import { useState, type FormEvent } from 'react'
import { api, Unauthorized, type User } from '../client/api.ts'

const passkeysWork = typeof window !== 'undefined' && 'PublicKeyCredential' in window

export function Login({ onDone }: { onDone: (user: User) => void }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const submit = async (e: FormEvent): Promise<void> => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      onDone((await api.login(username, password)).user)
    } catch (err) {
      setError(err instanceof Unauthorized ? 'Wrong username or password.' : err instanceof Error ? err.message : String(err))
    } finally {
      setBusy(false)
    }
  }
  const withPasskey = async (): Promise<void> => {
    setBusy(true)
    setError(null)
    try {
      const optionsJSON = (await api.passkeySignInOptions()) as PublicKeyCredentialRequestOptionsJSON
      const response = await startAuthentication({ optionsJSON })
      onDone((await api.passkeySignIn(response)).user)
    } catch (err) {
      const name = err instanceof Error ? err.name : ''
      if (name !== 'NotAllowedError' && name !== 'AbortError') setError(err instanceof Unauthorized ? 'This passkey is not known here.' : err instanceof Error ? err.message : String(err))
    } finally {
      setBusy(false)
    }
  }
  return (
    <form className="login" onSubmit={submit}>
      <h1>Solar</h1>
      {passkeysWork && (
        <>
          <button type="button" className="secondary" disabled={busy} onClick={() => void withPasskey()}>
            Sign in with a passkey
          </button>
          <div className="or">or</div>
        </>
      )}
      <label>
        Username
        <input autoComplete="username webauthn" value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
      </label>
      <label>
        Password
        <input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
      </label>
      {error && <p className="error">{error}</p>}
      <button disabled={busy || !username || !password}>{busy ? 'Signing in…' : 'Sign in'}</button>
    </form>
  )
}
